import { ServiceExecutionSequenceModel } from 'app/app-model/diagnostic-service/service-execution-sequence.model';

export class FlashModel {
  name: string;
  setSequence: ServiceExecutionSequenceModel;
  availableSecurityAccessModes: string[] = [];
}
